function commonCollection(integrationConstant, integrationSettingsService,
                          integrationViewService, gettextCatalog) {
    const vm = this;
    const manageDisplay = () => {
        // Integration type(pos,fulfilment)
        const parentComponentRules = vm.mapVisibleFeature;
        const actions = {
            collection: vm.data.collection,
            collectionWithTimeSlots: vm.data.collectionWithTimeSlots
        };
        const externalImpact = {
            parentComponentRules,
            siblingsComponent: actions,
            isUseMerchantSettings: vm.data.isUseMerchantSettings
        };
        // api visible parent and local events decides what's to display
        vm.visible = integrationViewService.getCollectionDisplay(externalImpact);
    };
    const commonUpdate = () => {
        vm.onDataUpdate({updatedData: vm.data});
        manageDisplay();
    };
    const manageInitialState = () => {
        vm.initialStateData = {toggle: vm.data.collection, posType: vm.data.posType};
    };
    vm.preparationTime = integrationSettingsService.getIntervals();
    vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
    vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;
    vm.FEATURES = {
        collection: {
            label: gettextCatalog.getString('Collection')
        }
    };
    vm.updateToggleCollection = () => {
        // for fulfilment there is not toggle validation
        if (vm.toggleSet) {
            vm.toggleSet.collection = vm.data.collection;
            vm.onToggleUpdate({toggleSet: vm.toggleSet});
        }
        // commonUpdate pass up to vm.onDataUpdate
        commonUpdate();
        manageInitialState();
        // need to be after onDataUpdate
        vm.onToggleCleanSubFeature({data : {value: vm.data.collection, type: 'col'}});
    };
    vm.collectionUpdate = () => {
       commonUpdate();
    };
    vm.$onInit = () => {
        vm.intervals = integrationSettingsService.getIntervals();
        // the names in this component are different because the names are bad in the domain.
        vm.data = integrationSettingsService.merge({}, vm.integrationData);
        vm.data.collectionIntervals = vm.data.collectionIntervals || vm.intervals[2].value;
        vm.data.preparationTime = vm.data.preparationTime || vm.intervals[2].value;
        vm.tooltipMessage = gettextCatalog.getString('Are you sure you want turn off this configuration? ' +
            'By doing this Takeaway menus won\'t be synchronized with your POS ' +
            'and your customer won\'t be able to see the most');

        manageInitialState();
        manageDisplay();
    };
    vm.$onChanges = (changesObj) => {
        if (changesObj.integrationData) {
            // Changes in the integrationData on the parent needs to be update
            vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
            manageDisplay();
            manageInitialState();
        }
        if (changesObj.mapVisibleFeature) {
            vm.mapVisibleFeature = changesObj.mapVisibleFeature.currentValue;
            manageDisplay();
            manageInitialState();
        }
    };
}

angular.module('qkr.integration.settings')
    .component('collection', {
        template: require('./collection.html'),
        bindings: {
            integrationData: '<',
            integrationForm: '<',
            mapVisibleFeature: '<',
            toggleSet: '<',
            location: '<',
            onDataUpdate: '&',
            onToggleUpdate: '&',
            onToggleCleanSubFeature: '&'
        },
        controller: commonCollection,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/common-feature/collection.component.js